import React from 'react';
import Logo from './Pop-Art.png';
import '../App.css';

function MyButton() {
  return (
    <button className="MyButton">
      I'm a button
    </button>
  );
}

const siteContent = {
  title: "宜しく WELCOME TO",
  subtitle: "SAL'S TV STATION",
  subtext: "حياكم الله"
};

function Home() {
  return (
    <>
    <div className="home">
      <h1 className="hero">{siteContent.title}</h1>
      <h1 className="subtitle">{siteContent.subtitle}</h1>
      <h1 className="subtitle">{siteContent.subtext}</h1>
      <img
        className="avatar"
        src={Logo}
        alt={'Photo of ' + siteContent.title}
      />
    </div>
    </>
  );
}

export default Home;
